import { RadioButtonWithLabelGroupWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';

export type EditConnectionDialogBridgeInfoProps = Readonly<{
  usingRemoteQueryAgent: boolean;
  showNetworkType: boolean;
  handleUsingRemoteQueryAgentChange: (usingRemoteQuery: boolean) => void;
}>;

export function EditConnectionDialogBridgeInfo(props: EditConnectionDialogBridgeInfoProps) {
  if (!props.showNetworkType) {
    return null;
  }
  else {
    return (
      <>
        <RadioButtonWithLabelGroupWidget
          label={Messages.editDataConnections_networkPrompt()}
          style={{ paddingTop: '24px' }}
          buttonList={[
            {
              label: Messages.editDataConnections_networkPublic(),
              testId: 'tableau-online',
              value: false,
            },
            {
              label: Messages.editDataConnections_networkPrivate(),
              testId: 'private-network',
              value: true,
            },
          ]}
          checkedIndex={props.usingRemoteQueryAgent ? 1 : 0}
          handleChange={props.handleUsingRemoteQueryAgentChange}
          data-tb-test-id='edit-conn-bridge-toggle'
        />
      </>
    );
  }
}

